import React, { useState } from 'react';
import './GalleryPage.css';

const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Gallery data organized by categories
  const galleryData = {
   
    foods: [
      { src: '/images/gallery/kerala food/kerala sadhya.jpg', alt: 'Kerala Sadya', title: 'Traditional Kerala Sadya' },
      { src: '/images/gallery/kerala food/appam with stew.jpg', alt: 'Appam with Stew', title: 'Appam with Stew' },
      { src: '/images/gallery/kerala food/fish curry.jpg', alt: 'Fish Curry', title: 'Kerala Fish Curry' },
      { src: '/images/gallery/kerala food/puttu and kadala.jpg', alt: 'Puttu and Kadala', title: 'Puttu and Kadala' },
      { src: '/images/gallery/kerala food/dosa.jpg', alt: 'Dosa', title: 'Kerala Style Dosa' },
      { src: '/images/gallery/kerala food/payasam.jpg', alt: 'Payasam', title: 'Traditional Payasam' },
      { src: '/images/gallery/kerala food/beef fry.jpg', alt: 'Beef Fry', title: 'Kerala Beef Fry' },
      { src: '/images/gallery/kerala food/banana chips.jpg', alt: 'Banana Chips', title: 'Kerala Banana Chips' }
    ],
    culturalEvents: [
      { src: '/images/gallery/cultural events/thrissur pooram.jpg', alt: 'Thrissur Pooram', title: 'Thrissur Pooram Festival' },
      { src: '/images/gallery/cultural events/onam celebration.jpg', alt: 'Onam Celebration', title: 'Onam Celebration' },
      { src: '/images/gallery/cultural events/boat race.jpg', alt: 'Boat Race', title: 'Snake Boat Race' },
      { src: '/images/gallery/cultural events/temple festival.jpg', alt: 'Temple Festival', title: 'Temple Festival' },
      { src: '/images/gallery/cultural events/pulikali dance.jpg', alt: 'Pulikkali', title: 'Pulikkali Dance' },
      { src: '/images/gallery/cultural events/pookalam.jpeg', alt: 'Flower Carpet', title: 'Pookalam (Flower Carpet)' },
      { src: '/images/gallery/cultural events/traditional music.jpg', alt: 'Traditional Music', title: 'Traditional Music Performance' },
      { src: '/images/gallery/cultural events/folk dance.jpg', alt: 'Folk Dance', title: 'Folk Dance Performance' },
    ],
    artForms: [
      { src: '/images/gallery/kerala art forms/kadakali.jpg', alt: 'Kathakali', title: 'Kathakali Performance' },
      { src: '/images/gallery/kerala art forms/theyyam.jpg', alt: 'Theyyam', title: 'Theyyam Ritual Art' },
      { src: '/images/gallery/kerala art forms/mohiniyattam.jpg', alt: 'Mohiniyattam', title: 'Mohiniyattam Dance' },
      { src: '/images/gallery/kerala art forms/koodiyattam.jpg', alt: 'Koodiyattam', title: 'Koodiyattam Performance' },
      { src: '/images/gallery/kerala art forms/ottamthullal.jpg', alt: 'Ottamthullal', title: 'Ottamthullal' },
      { src: '/images/gallery/kerala art forms/thiruvathirakali.jpg', alt: 'Thiruvathirakali', title: 'Thiruvathirakali' },
      { src: '/images/gallery/kerala art forms/chakyarkuthu.jpg', alt: 'Chakyar Koothu', title: 'Chakyar Koothu' },
      { src: '/images/gallery/kerala art forms/kalaripayattu.jpg', alt: 'Kalaripayattu', title: 'Kalaripayattu Martial Art' }
    ],
    places: [
        { src: '/images/gallery/destinations/wayanad1.jpg', alt: 'Wayanad Hills', title: 'Wayanad' },
        { src: '/images/gallery/destinations/munnar1.jpg', alt: 'Munnar Tea Gardens', title: 'Munnar' },
        { src: '/images/gallery/destinations/alleppey1.jpg', alt: 'Alleppey Backwaters', title: 'Alleppey' },
        { src: '/images/gallery/destinations/kumarakom1.jpg', alt: 'Kumarakom Lake', title: 'Kumarakom' },
        { src: '/images/gallery/destinations/varkala1.jpg', alt: 'Varkala Beach', title: 'Varkala' },
        { src: '/images/gallery/destinations/fortkochi1.jpg', alt: 'Fort Kochi', title: 'Fort Kochi' },
        { src: '/images/gallery/destinations/wayanad2.jpg', alt: 'Wayanad Wildlife', title: 'Wayanad Wildlife' },
        { src: '/images/gallery/destinations/munnar2.jpg', alt: 'Munnar Mountains', title: 'Munnar Hills' },
      ],
      floatingParadise: [
        { src: '/images/gallery/house boat/entrance.jpeg', alt: 'The Entrance View', title: 'The Entrance View' },
        { src: '/images/gallery/house boat/lounge.jpeg', alt: 'Lounge Area', title: 'Lounge Area' },
        { src: '/images/gallery/house boat/entertainment.jpeg', alt: 'Entertainment Zone', title: 'Entertainment Zone' },
        { src: '/images/gallery/house boat/vanity.jpeg', alt: 'Vanity Space', title: 'Vanity Space' },
        { src: '/images/gallery/house boat/bedroom.jpeg', alt: 'Cozy Bedroom', title: 'Cozy Bedroom' },
        { src: '/images/gallery/house boat/dining.jpeg', alt: 'Dining Hall', title: 'Dining Hall' },
        { src: '/images/gallery/house boat/premiumroom.jpeg', alt: 'Premium Room', title: 'Premium Room' },
        { src: '/images/gallery/house boat/bathroom.jpeg', alt: 'Private Bathroom', title: 'Private Bathroom' },
      ],
  };

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const GallerySection = ({ title, images, sectionId }) => (
    <section className="gallery-section" id={sectionId}>
      <h2 className="section-title">{title}</h2>
      <div className="gallery-grid">
        {images.map((image, index) => (
          <div key={index} className="gallery-item" onClick={() => openModal(image)}>
            <img src={image.src} alt={image.alt} loading="lazy" />
            <div className="gallery-overlay">
              <h3>{image.title}</h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );

  return (
    <div className="gallery-page">
      <div className="gallery-header">
        <h1>Kerala Gallery</h1>
        <p>Explore the beauty, culture, and traditions of God's Own Country</p>
      </div>

      <div className="gallery-nav">
        <a href="#places" className="nav-link">Places</a>
        <a href="#foods" className="nav-link">Kerala Foods</a>
        <a href="#cultural-events" className="nav-link">Cultural Events</a>
        <a href="#art-forms" className="nav-link">Art Forms</a>
        <a href="#floating-paradise" className="nav-link">Floating Paradise</a>
      </div>

      <div className="gallery-container">
        
        
        <GallerySection 
          title="Kerala Foods" 
          images={galleryData.foods} 
          sectionId="foods"
        />
        
        <GallerySection 
          title="Kerala Cultural Events" 
          images={galleryData.culturalEvents} 
          sectionId="cultural-events"
        />
        
        <GallerySection 
          title="Kerala Art Forms" 
          images={galleryData.artForms} 
          sectionId="art-forms"
        />
        <GallerySection 
          title="Places" 
          images={galleryData.places} 
          sectionId="places"
        />
         <GallerySection 
          title="Floating Paradise" 
          images={galleryData.floatingParadise} 
          sectionId="floating-paradise"
        />
      </div>

      {/* Modal for enlarged image view */}
      {selectedImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>&times;</button>
            <img src={selectedImage.src} alt={selectedImage.alt} />
            <h3>{selectedImage.title}</h3>
          </div>
        </div>
      )}
    </div>
  );
};

export default GalleryPage; 